export const NO_BEATS_LOW_DURATION_ARTIFACT_ERROR_MESSAGE =
  'It is not possible to create an Artifact event less than 10 seconds without beats.';

export const TEMPLATE_RATIO = {
  WIDTH: 0.5 * 0.75,
  HEIGHT: 0.75,
};
